import styled from "styled-components";

export const FooterMain = styled.footer`
    display: flex;
    background-color: #46C6CC;
    justify-content: space-between;
    align-items: center;
    color: #29201e;
    @media (max-width: 769px) {
        flex-wrap:wrap;
        flex-direction: column;
    }
`;

export const Logos = styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 769px) {
        display: flex;
        justify-content: space-around;
        align-items:center;
    }
`;

export const Logo = styled.img`
    width:64px;
    @media (max-width: 769px) {
        width:48px;
    }
`;

export const Title = styled.span`
    font-size: 1.5rem;
    @media (max-width: 769px) {
        padding-right: 0.3rem;
        font-size: 1rem;
    }
    @media (max-width: 1080px) {
        font-size: 1.2rem;
    }
`;

export const Contact = styled.span`
    
    font-size: 1.5rem;
    @media (max-width: 769px) {
        font-size: 1rem;
    }
    @media (max-width: 1080px) {
        font-size: 1.2rem;
    }
`;

export const UnifespLogo = styled.img`
    width:64px;
    margin-left:2rem;
    @media (max-width: 769px) {
        width:48px;
    }
`;

export const InstitutoLogo = styled.img`
    width:64px;
    margin-left:2rem;
    @media (max-width: 769px) {
        width:48px;
    }
`;